import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { RootState } from '../store/root.state';
import { NearbySchoolsStateModel } from './nearby-schools-state.model';
import { NearbySchoolsActions } from './nearby-schools.actions';
import { ContentService } from '../services/content.service';
import { INearbySchool } from '../types';

@State<NearbySchoolsStateModel>({
	name: 'nearbySchoolsState'
})
@Injectable()
export class NearbySchoolsState {
	constructor(
		private contentService: ContentService,
		private store: Store
	) {}

	@Selector()
	static nearbySchoolsApplying(state: NearbySchoolsStateModel) {
		return state.nearbySchoolsForm?.model.nearbySchools.filter((x: INearbySchool) => x.isApplying);
	}

	@Selector()
	static nearbySchools(state: NearbySchoolsStateModel) {
		return state.nearbySchoolsList;
	}

	@Selector()
	static selectedSchoolID(state: NearbySchoolsStateModel) {
		return state.selectedSchoolID;
	}

	@Action(NearbySchoolsActions.GetNearbySchools)
	getContent(ctx: StateContext<NearbySchoolsStateModel>, action: NearbySchoolsActions.GetNearbySchools) {
		const culture = this.store.selectSnapshot(RootState.culture);

		return this.contentService.getNearbySchools(action.lat, action.lng, culture).pipe(
			tap((result) => {
				const applyingSchoolID = this.store.selectSnapshot(RootState.content).schoolID;
				ctx.patchState({
					nearbySchoolsList: result.filter((r) => r.schoolID !== applyingSchoolID)
				});
			})
		);
	}

	@Action(NearbySchoolsActions.SelectNearbySchool)
	selectSchoolID(ctx: StateContext<NearbySchoolsStateModel>, action: NearbySchoolsActions.SelectNearbySchool) {
		const state = ctx.getState();
		ctx.setState({
			...state,
			selectedSchoolID: action.schoolID
		});
	}
}
